import rawAxios, { AxiosError, AxiosResponse, HttpStatusCode } from 'axios'
import { GeckoAuthenticationContext } from 'features/auth/geckoAuthContext'
import React, { FC, ReactNode, useMemo } from 'react'
/**
 * A component which handles SecondFront authentication, providing a GeckoAuthContext
 * to the rest of the app
 * @param children        The rest of the app (this component is a simple wrapper)
 */
export const SecondFrontAuthContext: FC<{
  children: ReactNode
}> = ({ children }) => {
  const authorizedAxios = useMemo(() => {
    const newAxios = rawAxios.create()
    // Make sure we pass the auth cookie with every request
    newAxios.defaults.withCredentials = true

    newAxios.interceptors.response.use(
      (response: AxiosResponse) => {
        // This is not great, but if we get a 401 from 2F, it likely
        // means the cookie expired, so we need to refresh the page
        // to trigger the login redirect
        if (response.status === HttpStatusCode.Unauthorized) {
          console.warn(
            `Response from axios call had status ${response.status}. Reload to trigger a login`
          )
          window.location.reload()
        }
        return response
      },
      (error: AxiosError) => {
        if (error?.status === HttpStatusCode.Unauthorized) {
          console.warn(error)
          console.warn(
            `Error response from axios call had status ${error?.status}. Reload to trigger a login`
          )
          window.location.reload()
        }
      }
    )

    return newAxios
  }, [])

  return (
    <GeckoAuthenticationContext.Provider
      value={{
        authorization: undefined,
        authorizedAxios,
        isAuthenticated: true,
        logout: () => {},
      }}>
      {children}
    </GeckoAuthenticationContext.Provider>
  )
}
